import React from 'react';
import './HeroContent.css'
import Button from '../Common/Button';

const HeroContent = () => {
    return ( 
        <div className='HeroContent'>
            <p className='HeroTitle'>Excellence in <span className='Gold'>Every Case.</span> </p>
            <p className='HeroSub'>A boutique legal practice offering refined expertise, personalized strategy, and results that matter.</p>
            <Button BtnText="Get in Contact"/>
        </div>
     );
}
 
export default HeroContent;